import { configure } from 'arktype/config';

configure({
    jitless: true,
});
